import { authHeader } from '../helpers/authHeader';
import { handleAxiosResponse, api_base_url, axiosInstance } from '../services/common.services';
import { handleServiceRequest } from '../services/handleServiceRequest';
import NotificationService from "./NotificationService";

export const scheduledJobsService = {
    getScheduledJobs,
};
const baseUrl = `/api/scheduled-jobs`;

function getScheduledJobs(startDate: string, endDate?: string): Promise<any>  {
    //dates should just look like YYYY-MM-DD
    let query = `?startDate=${startDate}`
    if(endDate)
        query += `&endDate=${endDate}`
    const getObject = {
        url: `${baseUrl}${query}`,
        customErrorMessage: `Failed to get scheduled jobs`,
    };
    return handleServiceRequest.get(getObject);
}